import { HierarchyValue } from 'RestAPIs/hierarchy';

import { LinkMode } from '../LinkPlanUnitForm.types';
import {
  HierarchyPlanUnit,
  isDescendant,
  isDirectDescendant
} from './treeHierarchy';

export const isAffectedByLinkMode = (
  selectedRow: HierarchyValue | undefined,
  row: HierarchyPlanUnit,
  linkMode: LinkMode
): boolean => {
  if (!row || !selectedRow) return false;

  switch (linkMode) {
    case 'PLAN_UNIT_ONLY':
      return row.brId?.toString() === selectedRow.brId?.toString();
    case 'ONLY_DIRECT_CHILDREN':
      return isDirectDescendant(selectedRow, row);
    case 'PLAN_UNIT_AND_ALL_OF_ITS_CHILDREN':
      return isDescendant(selectedRow, row);
    default:
      return false;
  }
};

export const getAffectedPlanUnits = (
  rows: HierarchyPlanUnit[],
  selectedRow: HierarchyValue | undefined,
  linkMode: LinkMode
): HierarchyPlanUnit[] =>
  rows.filter((row) => isAffectedByLinkMode(selectedRow, row, linkMode));
